module.exports = __webpack_public_path__ + "img/rec-09.7b623364.png";